module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vuetable', {
    ref: "vuetable2",
    attrs: {
      "fields": _vm.fields,
      "api-url": (_vm.server + "/api/drug-storage/"),
      "css": _vm.boostrapCss,
      "data-path": "results",
      "pagination-path": "",
      "perPage": 100,
      "append-params": _vm.moreParams,
      "detail-row-component": "adc-drug-detail"
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b1b98c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/DrugListDrugStorages.vue
// module id = 1441
// module chunks = 1